import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import useStore from '../store/store';
import { validPairsForOscilloscope } from "../constants/constants";
import style from './table.css';
import { TextField } from "@mui/material";

export default function TableComponent() {
    const eng = useStore((state) => state.eng);
    const brightness = useStore((state) => state.brightness);
    const focus = useStore((state) => state.focus);
    const level = useStore((state) => state.level);
    const rightRegulatorValue = useStore((state) => state.rightRegulatorValue);
    const durationGeneratorsRegulatorValue = useStore((state) => state.durationGeneratorsRegulatorValue);
    const amplitudeGeneratorsRegulatorValue = useStore((state) => state.amplitudeGeneratorsRegulatorValue);
    const oscillatorOn = useStore((state) => state.oscillatorOn);
    const generatorOn = useStore((state) => state.generatorOn);
    const membraneOn = useStore((state) => state.membraneOn);
    const showValuesStatus = useStore((state) => state.showValuesStatus);
    const exitGenerator_enterMembrane = useStore((state) => state.exitGenerator_enterMembrane);
    const exitMembrane_enterOcsilloscope = useStore((state) => state.exitMembrane_enterOcsilloscope);

    const [currentValues, setCurrentValues] = useState(Array(validPairsForOscilloscope.length).fill(''));
    const [error, setError] = useState(false); // State variable to track error state

    // Function to handle TextField change
    const handleTextFieldChange = (value, index) => {
        setCurrentValues(prevValues => {
            const newValues = [...prevValues];
            newValues[index] = value;
            return newValues;
        });
    };

    // Function to check if the entered value matches the pair.current
    const checkValue = (value, pair) => {
        return value == pair.current;
    };

    return (
        <Box className="tableFull">
            <Box sx={{display: 'flex', border: 'solid 5px black', justifyContent: 'space-between'}}>
                <Box sx={{
                    borderRight: 'solid 2px black',
                    paddingRight: '1px',
                    paddingLeft: '1px',
                    width: '54px'
                }}>
                    t
                    <sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>
                        <sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>
                            i
                        </sub>
                    </sub>
                    , ms
                </Box>
                { validPairsForOscilloscope.map((pair) => (
                    <Box
                        key={`${pair.duration}-${pair.amplitude}`}
                        sx={{
                            borderRight: 'solid 1px black',
                            paddingRight: '1px',
                            paddingLeft: '1px',
                            margin: 0,
                            width: '54px'
                        }}>

                        {(oscillatorOn && generatorOn && exitGenerator_enterMembrane && exitMembrane_enterOcsilloscope ) ? pair.duration : null}
                    </Box>
                ))}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    borderRight: 'solid 5px black',
                    borderLeft: 'solid 5px black',
                    borderBottom: 'solid 5px black',
                    justifyContent: 'space-between'
                }}>
                <Box
                    sx={{
                        borderRight: 'solid 2px black',
                        paddingRight: '1px',
                        paddingLeft: '1px',
                        width: '54px'
                    }}>
                    U
                    <sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>
                        <sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>
                            t
                        </sub>
                    </sub>
                    , V
                </Box>
                {validPairsForOscilloscope.map((pair, index) => (
                    <Box
                        key={`${pair.duration}-${pair.amplitude}`}
                        sx={{
                            borderRight: 'solid 1px black',
                            paddingRight: '1px',
                            paddingLeft: '1px',
                            margin: 0,
                            width: '54px'
                        }}
                    >
                        {oscillatorOn && generatorOn && exitGenerator_enterMembrane && exitMembrane_enterOcsilloscope && showValuesStatus[index] ? pair.amplitude : null}
                    </Box>
                ))}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    borderRight: 'solid 5px black',
                    borderLeft: 'solid 5px black',
                    borderBottom: 'solid 5px black',
                    justifyContent: 'space-between'
                }}>
                <Box
                    sx={{
                        borderRight: 'solid 2px black',
                        paddingRight: '1px',
                        paddingLeft: '1px',
                        width: '54px'
                    }}>
                    I
                    <sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>
                        <sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>
                            T
                        </sub>
                    </sub>
                    , mA
                </Box>
                {validPairsForOscilloscope.map((pair, index) => (
                    <Box
                        key={`${pair.duration}-${pair.amplitude}`}
                        sx={{
                            borderRight: 'solid 1px black',
                            paddingRight: '1px',
                            paddingLeft: '1px',
                            margin: 0,
                            width: '54px'
                        }}
                    >
                        {oscillatorOn && generatorOn && exitGenerator_enterMembrane && exitMembrane_enterOcsilloscope && showValuesStatus[index] ?
                            <TextField
                                value={currentValues[index]}
                                fullWidth
                                variant='filled'
                                sx={{ padding: 0, margin: 0, textAlign: 'left', fontSize: 'smaller',  width: '90%' }}
                                inputProps={{
                                    sx: {
                                        padding: 0,
                                    }
                                }}
                                onChange={(e) => handleTextFieldChange(e.target.value, index)}
                                onBlur={(e) => {
                                    if (!checkValue(e.target.value, pair)) {
                                        setCurrentValues(prevValues => {
                                            const newValues = [...prevValues];
                                            newValues[index] = '';
                                            return newValues;
                                        });
                                        setError(true); // Set error state to true
                                    } else {
                                        setError(false); // Set error state to false if no error
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        // Check value on pressing Enter
                                        if (!checkValue(e.target.value, pair)) {
                                            setCurrentValues(prevValues => {
                                                const newValues = [...prevValues];
                                                newValues[index] = '';
                                                return newValues;
                                            });
                                            setError(true); // Set error state to true
                                            alert('Значення струму не відповідає');
                                        } else {
                                            setError(false); // Set error state to false if no error
                                        }
                                    }
                                }}
                            />
                            : null}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}
